
export const Twitter = () => (
  <svg width='24' height='25' viewBox='0 0 24 25' fill='#666666' xmlns='http://www.w3.org/2000/svg'>
    <path d='M18.901 1.68457H22.581L14.541 10.8746L24 23.3776H16.594L10.794 15.7936L4.156 23.3776H0.474L9.074 13.5476L0 1.68557H7.594L12.837 8.61757L18.901 1.68457ZM17.61 21.1756H19.649L6.486 3.77157H4.298L17.61 21.1756Z' fill=''/>
  </svg>
);
